import OnboardingLayoutContentLarge from './OnboardingLayoutContentLarge';

export default OnboardingLayoutContentLarge;
